import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { ArticleEnvironment } from '../environment';
import { RecommendedResponse } from '../entities';

export class RecommendedRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).recommendedArticlesUrl, session);
  }

  getRecommendedArticles = (nid: number | string, userId = '', limit = 4): SafePromise<RecommendedResponse> => {
    const url = this.URL(`recommendations`, {
      limit,
      source_article_id: nid.toString(),
      user_id: userId,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
    });
  };
}
